class SimpleVideoPlayer {
    static create(source) {
        const sourceMP4 = document.createElement("source");
        sourceMP4.type = "video/mp4";
        sourceMP4.src = source;

        const videoElement = document.createElement("video");
        videoElement.appendChild(sourceMP4);
        videoElement.muted = true;

        const videoWrapperElement = document.createElement("div");
        videoWrapperElement.dataset.isPlaying = "false";
        videoWrapperElement.className = "simple-video-player";
        videoWrapperElement.appendChild(videoElement);
        videoWrapperElement.addEventListener("click", () => {
            if (videoWrapperElement.dataset.isPlaying === "false") {
                videoWrapperElement.dataset.isPlaying = "true";
                videoElement.play();
            } else {
                videoWrapperElement.dataset.isPlaying = "false";
                videoElement.pause();
            }
        });
        videoElement.addEventListener("ended", () => {
            videoWrapperElement.dataset.isPlaying = "false";
        });

        return videoWrapperElement;
    }
}

export { SimpleVideoPlayer };
